/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function t(t){return void 0===t||1===t}function n({scale:n,scaleX:r,scaleY:e}){return!t(n)||!t(r)||!t(e)}function r(t){return n(t)||e(t)||t.z||t.rotate||t.rotateX||t.rotateY}function e(t){return o(t.x)||o(t.y)}function o(t){return t&&"0%"!==t}export{e as has2DTranslate,n as hasScale,r as hasTransform};
//# sourceMappingURL=has-transform.js.map
